import { Pipe, PipeTransform } from '@angular/core';
import { ActionStepEnum } from 'src/app/model/analize-step-history';
import { InfoInputValue, StepAnalyseEnum } from 'src/app/model/analyse-credit';
import { isNotNullAndUndefined, isNullOrUndefined } from 'src/app/shared/helpers/utils';
import { IdNumberAndDescription, UtilsService } from '../services/utils.service';

@Pipe({ name: 'typePermissionUser' })
export class TypePermissionUserPipe implements PipeTransform {

	transform(value?: number): string {
		if (isNullOrUndefined(value)) {
			return '';
		}
		const type = UtilsService.TypePermissionUser.find(t => t.id === value);
		return type ? type.description : '';
	}

}

@Pipe({ name: 'stepAnalyse' })
export class StepAnalyseEnumPipe implements PipeTransform {

	transform(value?: number): string {
		if (isNullOrUndefined(value)) {
			return '';
		}
		const type = UtilsService.StepAnalyseEnums.find(t => t.id === value);
		return type ? type.description : '';
	}

}

@Pipe({ name: 'statusAnalyse' })
export class AnalysisStatusEnumPipe implements PipeTransform {

	transform(value?: number): string {
		if (isNullOrUndefined(value)) {
			return '';
		}
		const type = UtilsService.AnalysisStatusEnums.find(t => t.id === value);
		return type ? type.description : '';
	}

}

@Pipe({ name: 'plantingArea' })
export class PlantingAreaEnumPipe implements PipeTransform {

	transform(value?: number): string {
		if (isNullOrUndefined(value)) {
			return '';
		}
		const type = UtilsService.PlantingAreaEnums.find(t => t.id === value);
		return type ? type.description : '';
	}

}

@Pipe({ name: 'debtType' })
export class DebtTypeEnumPipe implements PipeTransform {

	transform(value?: number): string {
		if (isNullOrUndefined(value)) {
			return '';
		}
		const type = UtilsService.DebtTypeEnums.find(t => t.id === value);
		return type ? type.description : '';
	}

}

@Pipe({ name: 'actionStep' })
export class ActionStepEnumPipe implements PipeTransform {

	transform(value?: number, step?: StepAnalyseEnum): string {
		if (isNullOrUndefined(value)) {
			return '';
		}
		const type = UtilsService.ActionStepEnums.find(t => t.id === value);
		if (isNotNullAndUndefined(type) && isNotNullAndUndefined(step) && type.id === ActionStepEnum.DEFERRED_HIGHER) {
			if (step === StepAnalyseEnum.CORPORATIVO) {
				type.description = 'Parecer Diretivo';
			}
		}
		return type ? type.description : '';
	}

}

@Pipe({ name: 'infoInputValue' })
export class InfoInputValueEnumPipe implements PipeTransform {

	transform(value?: number): string {
		if (isNullOrUndefined(value)) {
			return '';
		}
		const type = UtilsService.InfoInputValueEnums.find(t => t.id === value);
		return type ? type.description : '';
	}

}

@Pipe({ name: 'ratingPipe' })
export class RatingEnumPipe implements PipeTransform {

	transform(value?: number): string {
		if (isNullOrUndefined(value)) {
			return '';
		}
		const type = UtilsService.RatingEnum.find(t => t.id === value);
		return type ? type.description : '';
	}

}

@Pipe({ name: 'fiscalYearPipe' })
export class FiscalYearEnumPipe implements PipeTransform {

	transform(value?: number): string {
		if (isNullOrUndefined(value)) {
			return '';
		}
		const type = UtilsService.FiscalYearEnum.find(t => t.id === value);
		return type ? type.description : '';
	}

}

@Pipe({ name: 'typeAnalysePipe' })
export class TypeAnalyseEnumPipe implements PipeTransform {

	transform(value?: number): string {
		if (isNullOrUndefined(value)) {
			return '';
		}
		const type = UtilsService.TypeAnalyseEnum.find(t => t.id === value);
		return type ? type.description : '';
	}

}

@Pipe({ name: 'typeDeliveryPipe' })
export class TypeDeliveryEnumPipe implements PipeTransform {

	transform(value?: number): string {
		console.log('typeDeliveryPipe -> ', value)
		if (isNullOrUndefined(value)) {
			return '';
		}
		const type = UtilsService.TypeDeliveryEnum.find(t => t.id === value);
		return type ? type.description : '';
	}

}